export const normalizeDomain = (line) => {
  let d = line.trim().toLowerCase();
  if (!d) return "";
  d = d.replace(/^https?:\/\//, "").replace(/^\/\//, "");
  d = d.split("/")[0].split("?")[0].split("#")[0];
  d = d.replace(/:\d+$/, "");
  return d;
};

export const rootDomain = (host) => {
  const parts = host.split(".");
  if (parts.length <= 2) return host;
  return parts.slice(-2).join(".");
};

export const parseDomains = (text, { excludeDupes, excludeSameDomain }) => {
  let list = text.split("\n").map(normalizeDomain).filter(Boolean);
  if (excludeDupes) list = [...new Set(list)];
  if (excludeSameDomain) {
    const seen = new Set();
    list = list.filter((d) => {
      const root = rootDomain(d);
      if (seen.has(root)) return false;
      seen.add(root);
      return true;
    });
  }
  return list;
};

export const fmtNum = (n) => {
  if (n === null || n === undefined) return "—";
  if (typeof n !== "number") return String(n);
  if (n >= 1e9) return (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6) return (n / 1e6).toFixed(2) + "M";
  if (n >= 1e3) return (n / 1e3).toFixed(1) + "K";
  return n.toLocaleString();
};

export const exportCSV = (rows) => {
  const headers = ["#", "Domain", "DA", "PA", "SS", "Backlinks", "Quality BL", "Ref. Domains", "DF Ref. Dom.", "Nofollow", "LP", "Outbound", "Status", "Last Crawl"];
  const lines = [headers.join(",")];
  rows.forEach((r, i) => {
    lines.push([i + 1, r.domain, r.da ?? "", r.pa ?? "", r.ss ?? "", r.backlinks ?? "", r.quality_bl ?? "", r.ref_domains ?? "", r.df_ref_domains ?? "", r.nofollow ?? "", r.lp ?? "", r.outbound ?? "", r.status, r.last_crawl ?? ""].join(","));
  });
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `wraith-checker-report-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
